import React from 'react';
import Routes from "../Routes";
import Sidebar from "./Sidebar";
import { BrowserRouter } from 'react-router-dom';
import { LoginFullScreen } from '../pages/LoginFullScreen';

import { useSelector } from 'react-redux';
import {
    isAuthenticated,
} from '../../AppSlice';

export function Layout(props) {
    const isAuth = useSelector(isAuthenticated);
    if (!isAuth) {
        return (
            <LoginFullScreen
                login={props.login}
            ></LoginFullScreen>
        );
    }
    return (
        <BrowserRouter>
            <div style={{ display: "flex" }}>
                {/* <button onClick={() => getCalendarEvents()}>teste</button> */}
                <Sidebar
                    authButtonMethod={isAuth ? props.logout : props.login}
                />
                <Routes />
            </div>
        </BrowserRouter>
    );
}


